<template>
    <div>
        <div class="bar-three" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="barDataThr.length != 0">
            <div class="per-line flex flex-j-c-sb" v-for="(e, i) in barDataThr" :key="`${i}three`">
                <div class="flex flex-a-i-center">
                <img :src="e.avatar_url" class="item-avatar"/>
                <div class="item-box flex flex-a-i-center flex-j-c-sb">
                    <p class="item-name">{{e.true_name}}</p>
                    <div style="width:100%" class="flex flex-a-i-center flex-j-c-sa">
                    <img src="@/assets/recruit/team_icon_tell@3x.png" class="item-phone"/>
                    <!-- <p @click="callPhone(e.mobile)">{{e.mobile}}</p> -->
                    <p class="herfPhone"><a :href="'tel:' + e.mobile">{{e.mobile}}</a></p>
                    </div>
                </div>
                </div>
                <div class="flex flex-a-i-center">
                <div class="item-box flex flex-a-i-center flex-j-c-sb">
                    <p class="item-time">{{e.create_time}}</p>
                    <div style="width:100%" class="flex flex-j-c-sa">
                    <p class="item-text item-texts" @click="assistanceHandle(e, 1)">不通过</p>
                    <p class="item-text" @click="assistanceHandle(e, 2)">通过</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <DataNull v-if="shownull"/>
        <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import {assistanceList, assistanceAdit} from '@/api';
import { MessageBox, Toast } from 'mint-ui';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';

export default {
  name: 'LevelThree',
  components: {
    DataNull,
    Nomore
  },
  data(){
    return{
      barDataThr: [], // 页面数据
      page: 1, // 页数
      loading: true, 
      shownull: false,
      showNoMore: false
    }
  },
  created() {
    this.getList();
  },
  methods: {
    // 加载更多
    loadMore(){
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getList();
    },
    // 获取列表
    getList() {
      assistanceList({page: this.page, limit: 20}).then(res => {
        if (res.code === 0) {
          res.data.list.map(item => {
            if (!item.avatar_url) {
              item.avatar_url = require('@/assets/teamAvatar.png');
            }
          })
          this.barDataThr = this.barDataThr.concat(res.data.list);
        } else {
          this.shownull = true;
        }
        if (res.data.list.length === 0) { this.shownull = true; }
        if (res.data.list.length === 20) { this.loading = false; }
        if (res.data.list.length !== 20 && res.data.list.length !== 0) { this.showNoMore = true };
      })
    },
    // 审核处理
    assistanceHandle(e, stu) {
        //stu:1不通过   2通过
        assistanceAdit({id: e.id, status: stu}).then(res => {
            if (res.code === 0) {
              Toast({message: '操作成功', duration: 2000});
              window.location.reload();
            } else {
              Toast({message: res.msg, className: 'iconfont icon-close', duration: 2000});
            }
        })
    },
    // 调用拨号功能
    callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber
    }
  },
};
</script>

<style scoped lang="less">
  .herfPhone{
    a{
      color: #666666;
    }
  }
</style>
